import { FC, useState } from 'react'
import { toast } from 'react-toastify'
import TrashCanOutline from 'mdi-material-ui/TrashCanOutline'
import { Close } from '@mui/icons-material'
import {
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  IconButton,
} from '@mui/material'
import { red } from '@mui/material/colors'
import { Accountant } from 'models/management.models'
import { selectActiveWorkspace } from 'lib/helpers/selectors'
import { errorToastOptions, successToastOptions } from 'lib/utils/toast.utils'
import { useAppSelector } from 'store/hooks'
import { deleteAccountantByID } from 'services/Management/management.services'
import { useManagementAccountantsContainerContext } from 'containers/Management/ManagementAccountants/ManagementAccountantsContainer/ManagementAccountantsContainer'
import Button from 'components/Shared/Button/Button'
import './styles.scss'

const ManagementAccountantsDeleteButton: FC<{
  accountant: Accountant
}> = ({ accountant }) => {
  const [isOpen, setIsOpen] = useState(false)
  const workspaceId = useAppSelector(selectActiveWorkspace)
  const { refetchManagementAccountants } =
    useManagementAccountantsContainerContext()

  const handleClick = (e: any) => {
    e.stopPropagation()
    setIsOpen(!isOpen)
  }

  const handleDelete = async () => {
    try {
      const { icon, closeButton, ...rest } = successToastOptions

      toast.loading('Eliminando usuario', {
        ...rest,
        toastId: 'loading',
      })
      setIsOpen(false)
      await deleteAccountantByID(workspaceId, accountant.idUser)
      await refetchManagementAccountants()
      toast.dismiss('loading')
      toast.success('Usuario eliminado correctamente', successToastOptions)
    } catch (err: any) {
      toast.dismiss('loading')
      if (err.status === 403) {
        toast.error(
          'No tienes los permisos suficientes para realizar esta acción',
          errorToastOptions
        )
        return
      }
      toast.error('No se ha podido eliminar el usuario', errorToastOptions)
    }
  }

  return (
    <div className="management-accountants-delete-button">
      <IconButton onClick={handleClick}>
        <TrashCanOutline style={{ color: red[500], fontSize: '18pt' }} />
      </IconButton>
      <Dialog
        onClose={handleClick}
        open={isOpen}
        className="management-accountants-delete-button-dialog">
        <DialogContent className="content">
          <Box className="close">
            <IconButton onClick={handleClick}>
              <Close />
            </IconButton>
          </Box>
          <Box className="labels">
            <Box className="title">Eliminar contador</Box>
            <Box className="subtitle">
              ¿Estás seguro de que deseas eliminar a este contador?
            </Box>
          </Box>
        </DialogContent>
        <DialogActions className="actions">
          <Button
            className="secondary"
            variant="outlined"
            onClick={handleClick}>
            Cancelar
          </Button>
          <Button
            className="primary"
            variant="contained"
            onClick={handleDelete}>
            Eliminar
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  )
}

export default ManagementAccountantsDeleteButton
